import { create } from "zustand";

export const useQuestion = create((set) => ({
  question: null,
  loading: true,
  error: null,
  setQuestion: (payload) => set({ question: payload, loading: false, error: null }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error, loading: false }),
}));
